import { DateTimeFormatter } from '@wix/premium-react-text';
import * as React from 'react';
import { Translation } from 'react-i18next';
import { Text } from 'wix-style-react';
import { PaymentCycle } from '../../../enums';

export interface ModalHeaderProps {
  planName: string;
  currentPlanPrice: string;
  paymentCycle: PaymentCycle;
  planEndDate: number;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  planName,
  currentPlanPrice,
  paymentCycle,
  planEndDate,
}) => (
  <Translation>
    {(t) => {
      const currentPlanCycle = t(
        `change_plan.current_plan_modal.${paymentCycle}.billed`,
      );
      return (
        <div>
          <DateTimeFormatter
            dateFormat='longMonth'
            render={(formatDate) => (
              <Text weight='thin' size='medium' data-testid='payment-details'>
                {t('change_plan.current_plan_modal.payment_details_advanced', {
                  planName,
                  price: currentPlanPrice,
                  cycle: currentPlanCycle,
                  endDate: formatDate(planEndDate),
                })}
              </Text>
            )}
          />
        </div>
      );
    }}
  </Translation>
);
